// External libraries
import styled from '@emotion/styled';

const ComponentContainer = styled.div`
  margin-bottom: 12px;
`;

const InputsContainer = styled.div`
  position: relative;
  white-space: nowrap;

  /* Containers for <PhoneType /> and <PhoneInput /> */
  > div {
    display: inline-block;
    position: relative;
    vertical-align: top;

    /* <PhoneType /> container */
    &:first-of-type {
      width: ${p => (p.canDialingCodeChange ? '120px' : '140px')};
      z-index: ${p => (p.phoneType?.displayError ? '1' : 'auto')};
    }

    /* <PhoneInput /> container */
    &:last-of-type {
      left: -1px;
      width: calc(100% - ${p => (p.canDialingCodeChange ? 80 : 139)}px);
      z-index: ${p => (p.phone?.displayError ? '1' : 'auto')};
    }

    /* Error message */
    p {
      white-space: pre-line;
    }
  }

  /* A focused input/select should always display the entire border */
  div.is-focused {
    z-index: 2;
  }
`;

const PhoneConfirmationText = styled.p`
  font-size: 15px;
  font-weight: normal;
  line-height: 1.2;
  margin-top: 6px;
  white-space: normal;
`;

export { ComponentContainer, InputsContainer, PhoneConfirmationText };
